import React from "react";
import { NumericFormat } from "react-number-format";

const Cards = ({ item, handleClick }) => {
  const { name, price, serialnumber, url } = item;
  return (
    <div className="card has-text-centered">
        <div className="card-content">
            <figure className="image is-128x128 is-inline-block">
                <img src={url} alt="Image" />
            </figure>
            <p>{name.substring(0, 22)+"..."}</p>
            <p>Serial: {serialnumber}</p>
            <p>Rp. <NumericFormat
                        value={price}
                        displayType="text" // Renders as a <span> instead of an input
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true} /></p>
            <button className="button is-small is-link mt-1" onClick={() => handleClick(item)}>Add to Contract</button>
        </div>
    </div>
  );
};

export default Cards;